// Format time for display and JSON
export const formatTime = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  const ms = Math.floor((seconds % 1) * 100);
  return `${mins}:${secs.toString().padStart(2, '0')}.${ms.toString().padStart(2, '0')}`;
};

// Parse formatted time string back to seconds
export const parseFormattedTime = (timeStr) => {
  const [minutesPart, secondsPart] = timeStr.split(':');
  const [seconds, centiseconds] = secondsPart.split('.');
  return parseInt(minutesPart) * 60 + parseInt(seconds) + parseInt(centiseconds) / 100;
};

// Helper function to snap time to nearest frame boundary
export const snapToFrame = (timestamp, fps) => {
  if (!fps) {
    throw new Error('FPS is required for snapToFrame');
  }
  return Math.round(timestamp * fps) / fps;
};

// Format frame for display
export const formatFrame = (seconds, videoDuration, fps) => {
  if (!fps) {
    throw new Error('FPS is required for formatFrame');
  }
  // Use Math.floor to show which frame is being DISPLAYED
  // Add epsilon (0.0001) to handle floating-point precision
  const frame = Math.floor(seconds * fps + 0.0001);
  const totalFrames = Math.floor(videoDuration * fps + 0.0001);
  return `${frame} / ${totalFrames}`;
};

// Calculate tolerance for frame-based operations
export const getFrameTolerance = (fps) => {
  if (!fps) {
    throw new Error('FPS is required for getFrameTolerance');
  }
  return 1 / fps / 2; // Half a frame tolerance
};

// Normalize time to frame boundary - converts any time value to the start time of its frame
// This removes browser-specific timing differences by always mapping to consistent frame boundaries
export const normalizeTimeToFrame = (time, fps) => {
  if (!fps) {
    return time;
  }
  // Convert time to frame number using consistent formula
  // Add epsilon (0.0001) to handle floating-point precision
  const frameNumber = Math.floor(time * fps + 0.0001);
  // Convert back to time (start of the frame)
  return frameNumber / fps;
}; 